<h3 mat-dialog-title>{{ data.editMode ? 'Edit Tutorial' : 'New Tutorial' }}</h3>
<mat-dialog-content>
  <div class="new-tutorial" [formGroup]="form">
    <mat-form-field class="new-tutorial__name">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field class="new-tutorial__description">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" rows="4"></textarea>
    </mat-form-field>

    <div class="new-tutorial__thumbnail-upload">
      <label>Thumbnail *</label>
      <div
        class="dropzone"
        appDragAndDrop
        (fileDropped)="handleThumbnailInput($event)"
        [matTooltip]="'Max file size: 25MB, Allowed formats: png, jpg, jpeg'"
        matTooltipPosition="above"
        matTooltipShowDelay="1000">
        <input
          type="file"
          #thumbnailDropRef
          id="thumbnailDropRef"
          [accept]="'.png, .jpg, .jpeg'"
          (change)="handleThumbnailInput($event.target)" />
        <span class="material-symbols-outlined upload-icon">cloud_upload</span>
        <div class="text-info">Drag and drop file here</div>
        <div class="thumbnail-name">{{ thumbnailName || 'No thumbnail selected' }}</div>
        <button mat-stroked-button for="thumbnailDropRef">Browse for thumbnail</button>
      </div>
    </div>

    <mat-form-field class="new-tutorial__tags">
      <mat-label>Tags</mat-label>
      <mat-chip-grid #chipGrid formControlName="tags">
        @for (tag of form.get('tags')?.value; track tag) {
          <mat-chip-row (removed)="remove(tag)">
            {{ tag }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>

      <input
        #tagInput
        placeholder="Add tags"
        [formControl]="tagCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)" />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        @for (tag of filteredTags$ | async; track tag) {
          <mat-option [value]="tag">{{ tag }}</mat-option>
        }
      </mat-autocomplete>
      <mat-icon
        matIconSuffix
        matTooltip="Only letters and numbers are allowed without spaces and special characters"
        matTooltipPosition="left"
        >help_outline
      </mat-icon>
    </mat-form-field>

    <div class="new-tutorial__internals">
      <label id="internalsOnly">Who can see tutorial: *</label>
      <mat-radio-group aria-labelledby="internalsOnly" formControlName="internalsOnly">
        <mat-radio-button [value]="true">Internals only</mat-radio-button>
        <mat-radio-button [value]="false">All users</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="new-tutorial__type">
      <label id="type">Type: *</label>
      <mat-radio-group aria-labelledby="type" formControlName="type">
        <mat-radio-button value="Video">Video</mat-radio-button>
        <mat-radio-button value="Pdf">PDF</mat-radio-button>
      </mat-radio-group>
    </div>

    @if (form.get('type')?.value === 'Video') {
      <mat-form-field class="new-tutorial__url">
        <mat-label>Video URL</mat-label>
        <input matInput formControlName="url" />
      </mat-form-field>
    }

    <div class="new-tutorial__file-upload">
      @if (form.get('type')?.value === 'Pdf') {
        <label>File *</label>
        <div
          class="dropzone"
          appDragAndDrop
          (fileDropped)="handleFileInput($event)"
          [matTooltip]="'Max file size: 25MB, Allowed format: PDF'"
          matTooltipPosition="above"
          matTooltipShowDelay="1000">
          <input
            type="file"
            #fileDropRef
            id="fileDropRef"
            [accept]="'.pdf'"
            (change)="handleFileInput($event.target)" />
          <span class="material-symbols-outlined upload-icon">cloud_upload</span>
          <div class="text-info">Drag and drop file here</div>
          <div class="file-name">{{ fileName || 'No file selected' }}</div>
          <button mat-stroked-button class="browse-button" for="fileDropRef">Browse for file</button>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">Close</button>
  @if (isSaving) {
    <button mat-flat-button [disabled]="isSaving">
      Saving
      <mat-icon>
        <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
      </mat-icon>
    </button>
  } @else {
    <button mat-flat-button (click)="save()" [disabled]="isSaving || isFormInvalid()">Save</button>
  }
</mat-dialog-actions>
